import { Button } from "@aph/ui-lib-humanx";
import React from "react";
import { VideoSliderItem } from "@/components/PageHome/api/interface";
import { RefsObjectType } from "@/components/PageHome/interfaces";
import { NON_ONBOARDED_STATUS } from "@/helpers/constants";
import { buttonClickedEvent } from "@/helpers/TSDEvents";
import { useAppSelector } from "@/redux/hooks";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import styles from "./SlideCard.module.scss";

interface CarouselCardProps extends VideoSliderItem {
  refs: RefsObjectType;
}

const CarouselCard: React.FC<CarouselCardProps> = ({ Title, titleVariant, Video, CTAText, id, refs }) => {
  const signedInStatus = useAppSelector(signedInStateSelector);

  const handleCTAClick = (): void => {
    // handle TSD
    buttonClickedEvent({
      button_name: CTAText,
      button_position: 1,
      momverse_stage: NON_ONBOARDED_STATUS,
      is_loggedin: signedInStatus === SignedinState.SIGNEDIN ? true : false,
    });

    if (refs?.current["onBoardingRef"]) {
      refs?.current["onBoardingRef"].scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div data-testid={`${id}-card`} className={styles.card}>
      <div data-testid={`${id}-mediaWrapper`} className={styles.mediaWrapper}>
        <video
          playsInline
          data-testid={`video`}
          autoPlay
          muted
          src={Video?.data?.attributes?.url}
          loop
          preload={"auto"}
          width={"100%"}
          height={200}
        />
      </div>
      <div className={styles.videoText}>
        {Title && (
          <h5 data-variant={titleVariant} className={styles.title} dangerouslySetInnerHTML={{ __html: Title }} />
        )}
        {CTAText && (
          <Button
            color="secondarybaby"
            size="lg"
            type={"button"}
            data-testid={`${id}-link`}
            onClick={handleCTAClick}
            className={styles.link}
          >
            {CTAText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CarouselCard;
